// Contents
import getConfigForLocale, { ConfigForLocale } from './initScripts/getConfigForLocale'
import { LayoutEnum } from './enums/LayoutEnum'
import { Contents } from "@/types/types"
import { LocalePackConfig } from './config/pack-config'
import { LocaleLodgingTypeConfig } from './config/lodging-type-config'
import { TF } from './types/global'
import {
    AttachStoreToBundle,
    AttachStoreToBundleParams,
    CreateUI,
    InitBundles,
    InitBundlesObj,
    InitUIProps,
    SEBundle,
    SubinitSE,
    SubinitSEParams
} from './types/types'
import { capacity } from './data/capacity'
import { getFilters } from './filters'
import { getCookies } from './utils/getCookies'
import { defaultCapacity, defaultParticipantsAges, defaultSeName } from './config/defaults'

const initBundles: InitBundles = (initObj: InitBundlesObj) => {
    // extract init params
    const locale: string = initObj.locale
    const desiredLanguage: string  | undefined = initObj.lang
    const packCode: string | undefined = initObj.packCode
    const seUniqueName: string | undefined = initObj.seUniqueName
    const seBarLayout: LayoutEnum | undefined = initObj.seBarLayout
    const customTopStations: number[] | undefined = initObj.customTopStations

    const seName: string = seUniqueName || defaultSeName

    const existingBundle = window.tf!.bundles!.se![seName]
    if (existingBundle) {
        console.error(`[initBundles "${seName}"] - cannot init se bundle for "${seName}" when it already exists; exiting`)
        return
    }

    const bundle: SEBundle = window.tf!.bundles!.se!.getBundle()
    window.tf!.bundles!.se![seName] = bundle

    const normalizedLocale: string= locale.replace(/-/g, '_')
    window.locale = normalizedLocale
    const configForLocale: ConfigForLocale = getConfigForLocale(normalizedLocale, desiredLanguage)
    const contents: Contents = configForLocale.contents
    const packageValues: LocalePackConfig = configForLocale.packageValues
    const lodgingTypes: LocaleLodgingTypeConfig = configForLocale.lodgingTypes

    const cookieObj: { [key: string]: string } = getCookies()

    const tf: TF = window.tf!

    const isCSE: boolean = locale === 'fr_FR_CSE' || locale === 'fr-FR-CSE'

    const company: string | null = isCSE ? cookieObj.company : null

    const fields = {
        // manual values
        capacity
    }
    const fieldCounters: string[] = ['country', 'region', 'domaineSki', 'parentStation', 'station', 'lodgingType', 'packages', 'capacity']
    const criteriaCounters: string[] = []
    const expandedCriteriaCounters: string[] = []

    const initStore: AttachStoreToBundle | null | undefined = tf.bundles!.se![seName]?.init?.store
    const initSE: SubinitSE | null | undefined = tf.bundles!.se![seName]?.init?.libs?.se
    const initUI: CreateUI | null | undefined = tf.bundles!.se![seName]?.init?.ui?.bar

    const initStoreParams: AttachStoreToBundleParams = {
        id: seName,
        locale,
        lang: initObj.lang,
        data: {
            fields,
            company
        },
        summer: initObj.summer,
        isCosog: initObj.isCosog
    }
    const initSEParams: SubinitSEParams = {
        id: seName,
        engineId: initObj.engineId,
        requestOptions: function () {
            return {
                urls: {
                    base: {
                        se: 'https://api.travelski.com/se'
                    }
                },
                ...(isCSE && { params: { company: company } }),
                locale
            }
        },
        fieldCounters,
        criteriaCounters,
        fields,
        adultAge: 18
    }
    const initUIParams: InitUIProps = {
        selector: initObj.selector,
        contents: {
            resultsUrl: '/se-results',
            resultsUrlSummer: '/se-results-summer',
            ...contents,
            searchEngineTitle: initObj.searchEngineTitle || '',
            searchEngineTitleTag: initObj.searchEngineTitleTag || ''
        },

        filters: getFilters(packageValues, lodgingTypes),
        fieldCounters,
        criteriaCounters,
        expandedCriteriaCounters,
        defaultParticipantsAges,
        defaultCapacity,
        seBarLayout,
        packCode,
        customTopStations
    }

    if (initStore) {
        initStore(initStoreParams)
    }
    if (initSE) {
        initSE(initSEParams)
    }
    if (initUI) {
        initUI(initUIParams)
    }
}

export default initBundles
